module.exports = __webpack_public_path__ + "static/media/gallery10.4413c58c.jpg";